document.addEventListener('DOMContentLoaded', () => {
  const megaMenus = document.querySelectorAll('.mega-menu');
  const megaLinks = document.querySelectorAll('a.header__menu-item.link');
  const header = document.querySelector('header');

  const setMegaMenuOpenState = (menu, state) => menu.setAttribute('open', state);
  const removeMegaMenuOpenState = (menu) => menu.removeAttribute('open');

  megaMenus.forEach(menu => {
    menu.addEventListener('mouseover', () => setMegaMenuOpenState(menu, true));

    menu.addEventListener('mouseout', () => {
      if (!header.matches(':hover')) removeMegaMenuOpenState(menu);
    });
  });

  megaLinks.forEach(link => {
    link.addEventListener('mouseover', () => {
      if (megaMenus.length >= 1 && megaMenus[0].hasAttribute('open')) {
        removeMegaMenuOpenState(megaMenus[0]);
      }
    });
  });
});